// Cambridge A2 Flyers vocab.js — Week 34
export default {
  vocab: [
  {
    "word": "hardworking",
    "definition_en": "tending to work with energy and commitment",
    "definition_vi": "chăm chỉ",
    "example": "The hardworking ant gathered food all summer.",
    "ipa": "/ˌhɑːdˈwɜː.kɪŋ/"
  },
  {
    "word": "grasshopper",
    "definition_en": "a plant-eating insect with long hind legs for leaping",
    "definition_vi": "con châu chấu",
    "example": "The grasshopper sang under the shady tree.",
    "ipa": "/ˈɡrɑːsˌhɒp.ər/"
  },
  {
    "word": "grain",
    "definition_en": "small hard seeds of food plants like wheat or corn",
    "definition_vi": "hạt lúa mì",
    "example": "Ants store wheat grain for the cold winter.",
    "ipa": "/ɡreɪn/"
  },
  {
    "word": "shivering",
    "definition_en": "shaking slightly because of being cold or frightened",
    "definition_vi": "run rẩy",
    "example": "He was shivering in the freezing winter wind.",
    "ipa": "/ˈʃɪv.ər.ɪŋ/"
  },
  {
    "word": "fable",
    "definition_en": "a short story typically with animals conveying a moral",
    "definition_vi": "truyện ngụ ngôn",
    "example": "Aesop wrote many famous animal fables.",
    "ipa": "/ˈfeɪ.bəl/"
  },
  {
    "word": "grateful",
    "definition_en": "feeling or showing an appreciation of kindness",
    "definition_vi": "biết ơn",
    "example": "The grasshopper felt deeply grateful to the ant.",
    "ipa": "/ˈɡreɪt.fəl/"
  },
  {
    "word": "diligence",
    "definition_en": "careful and persistent work or effort",
    "definition_vi": "sự siêng năng",
    "example": "His diligence paid off when winter came.",
    "ipa": "/ˈdɪl.ɪ.dʒəns/"
  },
  {
    "word": "patience",
    "definition_en": "the capacity to accept delay without getting angry",
    "definition_vi": "sự kiên nhẫn",
    "example": "Patience and hard work bring great success.",
    "ipa": "/ˈpeɪ.ʃəns/"
  },
  {
    "word": "moral",
    "definition_en": "a lesson derived from a story or experience",
    "definition_vi": "bài học đạo đức",
    "example": "Every fable has a clear moral lesson.",
    "ipa": "/ˈmɒr.əl/"
  },
  {
    "word": "cheerfully",
    "definition_en": "in a happy and optimistic manner",
    "definition_vi": "vui vẻ",
    "example": "He sang cheerfully during the warm summer.",
    "ipa": "/ˈtʃɪə.fəl.i/"
  },
  {
    "word": "freeze",
    "definition_en": "turn into ice as a result of extreme cold",
    "definition_vi": "đóng băng",
    "example": "Water rivers freeze during cold winter.",
    "ipa": "/friːz/"
  },
  {
    "word": "shelter",
    "definition_en": "a place giving protection from bad weather",
    "definition_vi": "nơi trú ẩn",
    "example": "The ant's house provided warm shelter.",
    "ipa": "/ˈʃel.tər/"
  },
  {
    "word": "gather",
    "definition_en": "bring together or collect from various places",
    "definition_vi": "thu thập",
    "example": "Ants gather seeds from the green field.",
    "ipa": "/ˈɡæð.ər/"
  },
  {
    "word": "prepare",
    "definition_en": "make something ready for use or consideration",
    "definition_vi": "chuẩn bị",
    "example": "Prepare early for cold winter months.",
    "ipa": "/prɪˈpeər/"
  },
  {
    "word": "wisdom",
    "definition_en": "the quality of having experience, knowledge, and good judgment",
    "definition_vi": "sự khôn ngoan",
    "example": "Ancient fables share timeless human wisdom.",
    "ipa": "/ˈwɪz.dəm/"
  },
  {
    "word": "kindness",
    "definition_en": "the quality of being friendly, generous, and considerate",
    "definition_vi": "lòng tốt",
    "example": "The ant showed great kindness to his friend.",
    "ipa": "/ˈkaɪnd.nəs/"
  },
  {
    "word": "season",
    "definition_en": "each of the four divisions of the year",
    "definition_vi": "mùa trong năm",
    "example": "Summer is the best season to collect food.",
    "ipa": "/ˈsiː.zən/"
  },
  {
    "word": "wheat",
    "definition_en": "a cereal plant cultivated for food grain",
    "definition_vi": "cây lúa mì",
    "example": "Golden wheat grew in the wide field.",
    "ipa": "/wiːt/"
  },
  {
    "word": "generous",
    "definition_en": "showing a readiness to give more of something than expected",
    "definition_vi": "hào phóng",
    "example": "The generous ant offered hot vegetable soup.",
    "ipa": "/ˈdʒen.ər.əs/"
  },
  {
    "word": "future",
    "definition_en": "the time or a period of time following the moment of speaking",
    "definition_vi": "tương lai",
    "example": "Work hard now to protect your future.",
    "ipa": "/ˈfjuː.tʃər/"
  }
]
};
